var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 62,
    viewBox: "0 0 55 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp 1",
    clipPath: "url(#clip0_915_17630)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.1246 11.7582C41.0508 6.67227 34.2937 3.875 27.1129 3.875C12.291 3.875 0.230078 15.9359 0.230078 30.7578C0.230078 35.4926 1.46523 40.1184 3.81445 44.1992L0 58.125L14.2527 54.3832C18.1762 56.5266 22.5961 57.6527 27.1008 57.6527H27.1129C41.9227 57.6527 54.25 45.5918 54.25 30.7699C54.25 23.5891 51.1984 16.8441 46.1246 11.7582ZM27.1129 53.1238C23.0926 53.1238 19.157 52.0461 15.7301 50.0117L14.9187 49.5273L6.46641 51.7434L8.71875 43.4969L8.18594 42.6492C5.9457 39.0891 4.77109 34.984 4.77109 30.7578C4.77109 18.4426 14.7977 8.41602 27.125 8.41602C33.0949 8.41602 38.7016 10.741 42.9156 14.9672C47.1297 19.1934 49.7211 24.8 49.709 30.7699C49.709 43.0973 39.4281 53.1238 27.1129 53.1238ZM39.3676 36.3887C38.7016 36.0496 35.3957 34.427 34.7781 34.209C34.1605 33.9789 33.7125 33.8699 33.2645 34.548C32.8164 35.2262 31.5328 36.7277 31.1332 37.1879C30.7457 37.6359 30.3461 37.6965 29.6801 37.3574C25.7324 35.3836 23.141 33.8336 20.5375 29.3652C19.8473 28.1785 21.2277 28.2633 22.5113 25.6961C22.7293 25.248 22.6203 24.8605 22.4508 24.5215C22.2812 24.1824 20.9371 20.8766 20.3801 19.5324C19.8352 18.2246 19.2781 18.4063 18.8664 18.382C18.4789 18.3578 18.0309 18.3578 17.5828 18.3578C17.1348 18.3578 16.4082 18.5273 15.7906 19.1934C15.173 19.8715 13.4414 21.4941 13.4414 24.8C13.4414 28.1059 15.8512 31.3027 16.1781 31.7508C16.5172 32.1988 20.9129 38.9801 27.6578 41.8984C31.9203 43.7391 33.5914 43.8965 35.7227 43.5816C37.0184 43.3879 39.6945 41.959 40.2516 40.3848C40.8086 38.8105 40.8086 37.4664 40.6391 37.1879C40.4816 36.8852 40.0336 36.7156 39.3676 36.3887Z",
    fill: "#AA182C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_915_17630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.25,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ec37d1e77315b660c910971f47576a6e.svg";
export { ForwardRef as ReactComponent };